import { render, staticRenderFns } from "./policy-docs.vue?vue&type=template&id=7f803b7e&scoped=true&"
import script from "./policy-docs.vue?vue&type=script&lang=js&"
export * from "./policy-docs.vue?vue&type=script&lang=js&"
import style0 from "./policy-docs.vue?vue&type=style&index=0&id=7f803b7e&lang=scss&scoped=true&"
import style1 from "./policy-docs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f803b7e",
  null
  
)

export default component.exports